/** Drain refused rename writes and rebuild every affected graph. */
export function rollbackRename(
  takeBacks: readonly (() => void)[],
  rebuildGraphs: readonly (() => void)[],
): void {
  for (const takeBack of takeBacks) {
    try {
      takeBack();
    } catch {
      // Drain every begun write even when a correction observer throws.
    }
  }
  for (const rebuild of rebuildGraphs) {
    try {
      rebuild();
    } catch {
      // One failed graph cannot skip the other sheets' follow-through.
    }
  }
}
